import { Flex } from "@mantine/core";
import { ReactNode } from "react";

import { DEFAULT_SPACING, DEFAULT_SPACING_MOBILE } from "~/utils/Constants";

import { Footer } from "./PageContainer";

const PublicPageContainer = ({
  children,
  bgcolor,
}: {
  children: ReactNode;
  bgcolor?: string;
}) => {
  return (
    <Flex
      direction="column"
      miw={360}
      h="100%"
      pb={{
        base: (DEFAULT_SPACING_MOBILE / 3) * 8,
        md: (DEFAULT_SPACING / 3) * 8,
      }}
      bg={bgcolor}
    >
      <Flex direction="column" h="100%" align="center">
        <Flex
          direction="column"
          flex={1}
          display={{ base: "none", sm: "flex" }}
        />
        <Flex direction="column" flex={5} p={24} w="100%">
          {children}
        </Flex>
        <Footer />
      </Flex>
    </Flex>
  );
};

export default PublicPageContainer;
